<template>
  <div class="main-body">
    <div class="header">睡眠雷达</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" icon="el-icon-plus" plain @click.native="toggleModalAdd">绑定设备</el-button>
        <!--        <el-button size="mini" plain @click.native="openBigView">动态展示</el-button>-->

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 5px">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini" placeholder="请输入设备号" v-model="imei" clearable style="margin-right:5px;width:150px"></el-input>

          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>

        <el-table-column prop="userName" label="用户名" width="100"></el-table-column>
        <el-table-column prop="phone" label="用户手机号" width="150" :formatter="getPhoneStr"></el-table-column>
        <el-table-column prop="imei" label="设备号" width="200"></el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.deviceType==1">清雷</span>
            <span v-if="scope.row.deviceType==2">驰通达</span>
            <span v-if="scope.row.deviceType==3">欧万</span>
            <span v-if="scope.row.deviceType==4">睡倍健</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">

            <el-button type="text" size="mini" @click="RemoveBinding(scope.row)">解绑</el-button>
            <el-button type="text" size="mini" @click="getData(scope.$index, scope.row)">数据</el-button>

            <el-button v-if="scope.row.deviceType==2" type="text" size="mini"  @click="setICCID(scope.row)">卡号</el-button>
            <el-button v-if="scope.row.deviceType==2" type="text" size="mini" @click="setBmdCTD(scope.row)">白名单</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false" v-on:getList="getList"></Add>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>
    <BigView ref="myBigView" v-show="showModalBigView"  v-on:closeBigView="closeBigView"></BigView>

    <SBJData ref="SBJData"  v-show="sBJDataShow" v-on:closeSBJData="sBJDataShow=false"></SBJData>
    <SBJDataCYD ref="SBJDataCYD" v-show="sBJDataShowCYD" v-on:closeSBJData="sBJDataShowCYD=false"></SBJDataCYD>
    <SBJDataOW ref="SBJDataOW" v-show="sBJDataShowOW" v-on:closeSBJData="sBJDataShowOW=false"></SBJDataOW>
    <SBJDataYJ ref="SBJDataYJ" v-show="sBJDataShowYJ" v-on:closeSBJData="sBJDataShowYJ=false"></SBJDataYJ>

    <SetICCID ref="mySetICCID" v-show="iccidShow" v-on:closeMe="iccidShow=false"></SetICCID>
    <SetBmdCTD ref="mySetBmdCTD" v-show="bmdShow" v-on:closeMe="bmdShow=false"></SetBmdCTD>

  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getGovernmentCode} from "@/utils/auth";

import Add from "./AddDisable"
import Elderly from "@/views/Elderly/Comm/ElderlyGovClass";
import BigView from "./BigView";

import SBJData from "../Comm/SBJData";
import SBJDataCYD from "../Comm/SBJDataCYD";
import SBJDataOW from "../Comm/SBJDataOW";
import SBJDataYJ from "../Comm/SBJDataYJ";

import SetICCID from "../Comm/SetICCID";
import SetBmdCTD from "../Comm/SetBmdCTD"

export default {
  name: "Role",
  data() {
    return {

      showModalAdd:false,
      tableLoading:false,

      sBJDataShow:false,
      sBJDataShowCYD:false,
      sBJDataShowOW:false,
      sBJDataShowYJ:false,

      iccidShow:false,
      bmdShow:false,

      showModalGetElderly:false,
      showModalBigView:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imei: "",


    };
  },
  components: {Add,Elderly,BigView,
    SBJData,SBJDataCYD,SBJDataOW,SBJDataYJ,
    SetICCID,SetBmdCTD},
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },

    getPhoneStr(row,index,column){
      let str = "";
      if(column && column.length == 11){
        str = column.substring(0,3)+"****"+column.substring(7,11);
      }else{
        str = column;
      }
      return str;
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },

    setICCID(row){
      this.$refs.mySetICCID.init(row);
      this.iccidShow =!this.iccidShow;
    },
    setBmdCTD(row){
      this.$refs.mySetBmdCTD.init(row);
      this.bmdShow =!this.bmdShow;
    },

    getData(index,row){
      let deviceType = row.deviceType;
      if(deviceType == 1){
        this.$refs.SBJData.init(row.userCode);
        this.sBJDataShow =!this.sBJDataShow;
      }
      if(deviceType == 2){
        this.$refs.SBJDataCYD.init(row.userCode);
        this.sBJDataShowCYD =!this.sBJDataShowCYD;
      }
      if(deviceType == 3){
        this.$refs.SBJDataOW.init(row.userCode);
        this.sBJDataShowOW =!this.sBJDataShowOW;
      }
      if(deviceType == 4){
        this.$refs.SBJDataYJ.init(row.userCode);
        this.sBJDataShowYJ =!this.sBJDataShowYJ;
      }
    },

    openBigView(){
      this.showModalBigView = !this.showModalBigView;
      this.$refs.myBigView.init();
    },
    closeBigView(){
      this.showModalBigView =!this.showModalBigView;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceQLSign/PageByGovCodeClassName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          imei: this.imei,
          userCode: this.userCode,
          elderlyClassName:'残疾人',
        },
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },

    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要解绑该用户的设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          method: "post",
          url: this.$deviceUrl + "DeviceQLSign/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            deviceQLSignCode: row.deviceQLSignCode,
          },
        }).then((response) => {
          //console.log(response);
          if (response.data.error == 0) {
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {
        //this.$message({type: "info", message: "已取消解绑",});
      });
    },



  },
};
</script>

<style scoped>

</style>
